import { copyToClipboard } from '../../../components/copy-to-clipboard';
import { toast } from 'react-hot-toast';
import { Modal } from '../../../../../design-system/components/modal/modal';
import { Typography } from '../../../../../design-system/components/typography/typography';
import { Button } from '../../../../../design-system/components/button/button';
import { Tooltip } from '../../../../../design-system/components/tooltip/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { faFlower, faMoneyBillWave } from '@fortawesome/pro-solid-svg-icons';
import { sprinkles } from '../../../../../design-system/sprinkles.css';
import campaignSuccessImage from '/static/images/marketing/campaign-success.png';

export const SuccessModal = (p: {
  isOpen: boolean;
  onClose: () => void;
  url: string;
}) => (
  <Modal isOpen={p.isOpen} onClose={p.onClose} title="">
    <div className="flex gap-2">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minWidth: '400px',
          flex: '1',
        }}
      >
        <div className="flex flex-row">
          <div className="flex-1">
            <Typography variant="headline" size="small">
              Campaign link
            </Typography>
          </div>
          <div>
            <Tooltip title={<CampaignInfo />} variant="white">
              <FontAwesomeIcon
                color="black"
                icon={faInfoCircle}
                className="mr-[40px] lg:mr-0"
              />
            </Tooltip>
          </div>
        </div>

        <div
          style={{
            borderRadius: '8px',
            padding: '12px',

            marginTop: '16px',
          }}
          className={sprinkles({ bg: 'N-20' })}
        >
          <Typography variant="body" size="large">
            {p.url}
          </Typography>
        </div>

        <div className="flex  justify-end mt-[1em]">
          <Button
            onClick={() => {
              p.onClose();
              toast.success('Link copied to clipboard');
              copyToClipboard(p.url);
            }}
            color="neutral"
            style={{ minWidth: '120px' }}
          >
            {'Copy link & close'}
          </Button>
        </div>
      </div>
      <div className="hidden lg:block">
        <div style={{}}>
          <img src={campaignSuccessImage} width="340px" />
        </div>
      </div>
    </div>
  </Modal>
);

const CampaignInfo = () => (
  <div className="p-[1em]">
    <Typography variant="body" size="medium" style={{ padding: '0 0 16px' }}>
      What to do next?
    </Typography>
    <Typography
      variant="body"
      size="small"
      color="N-80"
      style={{ paddingBottom: '8px' }}
    >
      <FontAwesomeIcon
        color="N-80"
        icon={faMoneyBillWave}
        style={{ paddingRight: '8px' }}
      />
      PAID ADS
    </Typography>
    <Typography variant="body" size="small">
      If you’re running paid campaign such as Facebook or Instagram ads - make
      sure to add this URL to the Campaign Manager.{' '}
    </Typography>
    <Typography
      variant="body"
      size="small"
      color="N-80"
      style={{ paddingBottom: '8px', paddingTop: '16px' }}
    >
      <FontAwesomeIcon
        color="N-80"
        icon={faFlower}
        style={{ paddingRight: '8px', textTransform: 'uppercase' }}
      />
      ORGANIC CAMPAIGN
    </Typography>
    <Typography variant="body" size="small">
      Make sure to paste link in respective place like Linktree, Instagram
      stories, email etc.
    </Typography>
  </div>
);
